export default __webpack_public_path__ + "static/media/people-soft.5cc56855.svg";